import React, { useEffect, useState } from 'react';
import QuizLikertScale from '@anu/components/QuizLikertScale';
import PropTypes from 'prop-types';
import {
  getStoredQuestion,
  setStoredQuestion,
} from '../utilities/session.question';

const QuizLikertScaleHandler = ({
  question,
  options,
  submittedAnswer,
  isSubmitting: pIsSubmitting,
  isSubmitted: pIsSubmitted,
  correctQuizValue = null,
  ...props
}) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    // During the initialization set the default value for the widget.
    if (props.course && props.course.private_sessions) {
      const submittedAnswer = getStoredQuestion(props.aqid);
      if (submittedAnswer) {
        setValue(submittedAnswer);
        props.onQuestionComplete(props.aqid);
      }
    }
  }, []);

  const onChange = (event, value) => {
    setValue(value);
    setStoredQuestion(props.aqid, value);
    props.onQuestionComplete(props.aqid);
  }

  return (
    <QuizLikertScale
      question={question}
      options={options}
      value={submittedAnswer || value}
      correctValue={correctQuizValue}
      isSubmitting={pIsSubmitting}
      isSubmitted={pIsSubmitted}
      onChange={onChange}
    />
  );
};

QuizLikertScaleHandler.propTypes = {
  onChange: PropTypes.func,
  isQuiz: PropTypes.bool,
  aqid: PropTypes.number,
  onQuestionComplete: PropTypes.func,
  question: PropTypes.string,
  options: PropTypes.array,
  submittedAnswer: PropTypes.string,
  correctQuizValue: PropTypes.array,
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
};

export default QuizLikertScaleHandler;
